module.exports = __webpack_public_path__ + "img/placemint-man.891b1b88.png";